import { procoreClient } from "./client";

type Location = {
    id: string;
    name: string;
    node_name: string;
};

export async function getLocations(params: {
    companyId: number;
    projectId: number;
    locationIds: string[];
}): Promise<Location[]> {
    if (!params.locationIds || params.locationIds.length === 0) {
        return [];
    }

    const searchParams = new URLSearchParams();
    searchParams.set("filters[id]", `[${params.locationIds.join(",")}]`);

    const response = await procoreClient<{ data: Location[] }>(
        `/rest/v2.0/companies/${params.companyId}/projects/${params.projectId}/locations?${searchParams.toString()}`,
        {
            method: "GET",
        },
    );

    return response.data;
}
